'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-tree', {
      url: '/document-tree/:type',
      template: '<document-tree></document-tree>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/document/tree/document-tree.routes.js